import React, { useState, useEffect, useRef } from "react";
import '../App.css';
import { useNavigate } from 'react-router-dom';
import AppTopBar2 from './common/app-top-bar2';
import AppLoading from './common/app-loading';
import { Box, Chip, Drawer, 
  Select, Tooltip, Typography, MenuItem, Grid 
} from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import IconButton from '@mui/material/IconButton';
import InfoIcon from "@mui/icons-material/Info";
import { AppHelper } from '../AppHelper';
import { EssayHelper } from '../helpers/essay.helper';
import SpaCheck from './common/spa-check';
import PopSuggestion from "./common/pop-suggestion";
import HomeDrawerExercise from "./home-drawer-exercise";
import { useEssayContext } from "../contexts/context-essay";
import { useExerciseContext } from "../contexts/context-exercise";
import SentenceTransformForm from "./sentence-transformation/sentence-transform-form";
import SentenceTransformView from "./sentence-transformation/sentence-transform-view";
import SentenceTransformAttempt from "./sentence-transformation/sentence-transform-attempt";

const dayjs = require('dayjs');

export default function PageHomeExercise() {
  const navigate = useNavigate();
  var oUser = AppHelper.userCacheGet();
  const [isLoading, setIsLoading] = useState(false);
  const drawerWidth = 240;

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);
  const [viewMode, setViewMode] = React.useState('NEW');
  const [refreshList, setRefreshList] = React.useState(false);
  const [recEssay, setRecEssay] = React.useState({});
  const [autoSelectId, setAutoSelectId] = React.useState('');
  const scoreCodesV2 = [
    { c:'GM', c2: 'grammar', n:'Grammar', v:0, p:0, eg: [], sub: [], expand: false }, 
    { c:'SP', c2: 'spelling', n:'Spelling', v:0, p:0, eg: [], sub: [], expand: false },
    { c:'VC', c2: 'vocabulary', n:'Vocabulary', v:0, p:0, eg: [], sub: [], expand: false }, 
    { c:'ST', c2: 'structure', n:'Structure', v:0, p:0, eg: [], sub: [], expand: false },
  ];
  const [filterEssay, setFilterEssay] = React.useState('');
  const [profiles, setProfiles] = React.useState([]);
  const [profileId, setProfileId] = useState('');
  const refTopBar = useRef(null);
  const [isSa, setIsSa] = React.useState(false);
  const [popShowFeedbackOpen, setPopShowFeedbackOpen] = useState(false);

  const {essayList, isEssayListLoaded, loadEssayList, essaySelect, essayRemove} = useEssayContext();
  const {recList, isListLoaded, loadList, recSelect} = useExerciseContext();

  useEffect(()=>{
    if(!oUser) return;
    if(!isEssayListLoaded){
      return;
    }
    else{
    }
  }, [isEssayListLoaded]);
  useEffect(()=>{
    if(!oUser){
      navigate('/login');
      return;
    }
    essaySelect('');
    AppHelper.apiAuditPost("P-H", "");
    if(!oUser.profileId){
    }
    if(profileId=='') setProfileId(oUser.profileId);

    const fetchIAM = async()=>{
      var _res = await AppHelper.apiPost('api/account/iam', {token: oUser.token});
      if(!_res || !_res.status || !_res.data || !_res.data.isSa){
        return;
      }
      setIsSa(true);
    }
    fetchIAM();
    const fetchProfiles = async () => {
      try {
        const response = await AppHelper.apiPost('api/profile-linked/list', {token: oUser.token});
        if (response && response.status && response.data) {
          setProfiles(response.data);
        } else {
          console.error('Failed to fetch profiles:', response);
        }
      } catch (error) {
        console.error('Error fetching profiles:', error);
      }
    };
    fetchProfiles();
  }, []);
  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };
  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };
  const onSelectItem = (arg) => {
    setRecEssay(arg);
    setViewMode(arg.status == 0? 'NEW': 'VIEW');
    recSelect(arg.exerciseId);
		if(mobileOpen) setMobileOpen(false);
  };
  const essayAddClick = ()=>{
    setViewMode('NEW');
    essaySelect('');
    setRecEssay({
      topic:"",
      text:"",
      essayId:""
    });
    setAutoSelectId("");
    if(mobileOpen) setMobileOpen(false);
  }
  const listFilterEssay = ()=>{
    var _list = [...essayList];
    if(filterEssay && filterEssay.length>0){
      var _filterText = filterEssay.toLowerCase();
      _list = _list.filter(r=>
         r.versionTitle.toLowerCase().includes(_filterText)
      );
    }
    return _list;
  };
  const profileSelect = async(arg) =>{
    setProfileId(arg.target.value);
    var _profile = profiles.find(p=>p.profileId == arg.target.value);
    if(!_profile){
      alert('Profile data not found!');
      return;
    }
    var _oUserSwitch = {...oUser};
    _oUserSwitch.name = _profile.name;
    _oUserSwitch.profileId = _profile.profileId;
    _oUserSwitch.grade = _profile.grade;
    _oUserSwitch.picture = _profile.avatarImage;
    _oUserSwitch.countryCode = _profile.countryCode;
    _oUserSwitch.locale = _profile.locale;
    if (_profile.isLinked == true) {
      _oUserSwitch.accountType = _profile.linkedRole;
    }
    AppHelper.userCacheSet(_oUserSwitch);
    oUser = AppHelper.userCacheGet();
    loadList(oUser);
    if(refTopBar){
      refTopBar.current.refreshProfile();
    }
  };
  const mobileOpenClick = (arg)=>{
    setMobileOpen(!mobileOpen);
  };
  const popShowFeedbackClose = ()=>{
    setPopShowFeedbackOpen(false);
  };
  const submitDone = (arg)=>{
    if(arg.code && arg.code == 'NEW'){
      //setAutoSelectId(arg.essayId);
      if(oUser) loadList(oUser, arg.argId);
      
      setRecEssay({exerciseId: arg.argId});
      setViewMode('VIEW');
    }
    else{
      setRefreshList(!refreshList);
    }
  };
  const tryAgain = (arg) => {
    if(arg.code && arg.code == 'AGAIN'){
      setViewMode('AGAIN');
    }
  }
  
  const onViewDone = ()=>{
    if(oUser) loadList(oUser);
    setViewMode('NEW');
  }

  const container = window !== undefined ? () => window.document.body : undefined;
  return (
    <Box sx={{display:'flex'}}>
      <AppTopBar2 mobileOpen={mobileOpen} mobileOpenClick={mobileOpenClick} ref={refTopBar} isExerciseHome={true} />
      {isLoading? (
        <AppLoading />
      ):(
      <>
      <Box backgroundColor="#000"
        component="nav"
        sx={{ width: { md: drawerWidth }, flexShrink: { sm: 0, md:0 }, border:'0 solid red' }}
      >
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onTransitionEnd={handleDrawerTransitionEnd}
          onClose={handleDrawerClose}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'block', md:'none' },
            minWidth: '300px',
          }}
        >
          {/* {drawer} */}
          <HomeDrawerExercise onSelectItem={onSelectItem} essayAddClick={essayAddClick} isSa={isSa} viewMode={viewMode}/>
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'none', md: 'block' },
            minWidth:'300px'
          }}
          PaperProps={{
            sx: {
              backgroundColor:'#f1f1f1',
              marginTop:'65px',
              width: drawerWidth
            }
          }}
          open
        >
          {/* {drawer} */}
          <HomeDrawerExercise onSelectItem={onSelectItem} essayAddClick={essayAddClick} isSa={isSa} viewMode={viewMode} />
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 3, width: { md: `calc(100% - ${drawerWidth}px)` }, marginTop:'50px' }}
      >
        <Grid container>
          <Grid item xs={6}>
            { profiles && profiles.length>1 && (
              <Select labelId='lblProfile' 
                value={profileId}
                onChange={profileSelect}
                label=""
                sx={{ "& fieldset": { border: 'none' }, marginLeft:'-12px' }}
              >
                {profiles.map((item) => (
                  <MenuItem key={item.profileId} value={item.profileId}>
                    {item.isLinked === true ? (
                      <>
                      <Box>
                      <Typography component='span'>{item.name} ({item.grade})</Typography>
                        <Chip label={'LINKED'} variant="filled" style={{
                          backgroundColor: "grey",
                          color: "white",
                          size: "small", 
                          height: "20px", 
                          marginLeft: '5px',
                          marginRight: '-5px', 
                          marginTop: '-2px'
                        }} />
                        <Tooltip sx={{marginRight: "-10px", marginTop: '-2px'}} title={`Linked from ${item.email}`}>
                          <IconButton>
                            <InfoIcon />
                          </IconButton>
                        </Tooltip>
                      </Box>
                      </>
                    ) : 
                    `${item.name}`}
                  </MenuItem>
                ))}
              </Select>
            )}
          </Grid>
        </Grid>
		
        {
          viewMode=='NEW' &&
          <SentenceTransformForm submitDone={submitDone} tryAgain={tryAgain} oUser={oUser}></SentenceTransformForm>
        }
        {
          viewMode=='AGAIN' &&
          <SentenceTransformAttempt submitDone={submitDone} isListLoaded={isListLoaded} oUser={oUser} recList={recList}></SentenceTransformAttempt>
        }
        {
          viewMode=='VIEW' &&
          <SentenceTransformView exerciseId={recEssay.exerciseId}
            onViewDone={onViewDone}  profileId={profileId} isSa={isSa} isSample={recEssay && recEssay.isSample}
          ></SentenceTransformView>
        }
      </Box>
      </>
      )}
      <SpaCheck></SpaCheck>
      <PopSuggestion
        open={popShowFeedbackOpen}
        onClose={popShowFeedbackClose}
        essayId={recEssay.essayId}
      />
    </Box>
  );
}
